import { FormikProps, useFormikContext } from '../../../../lib/formik/Formik'
import { InvestmentFundType } from "../../../../redux-store/types/api-types"
import { MpowerValidationType, SwitchNavigationProps } from "../../types"
import { MandateCreation } from "../../../../redux-store/types/investorProfile"
import { CircularProgress, Divider, Grid, IconButton, Skeleton, Typography, useTheme } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { RootStateType } from "../../../../redux-store/reducers"
import { useState } from "react"
import dayjs from "../../../../utils/dayjs"
import { Box } from "@mui/system"
import { checkImageExists, formatCurrency } from "../../../../utils/utilityFunctions"
import { BlueEditIcon, DeleteIcons } from "../../../../assets/SvgIcons"
import HoldingModal from '../common/HoldingModal'
import { CustomeBlueDatePicker, CustomeBlueDropDown, CustomeNumberInput } from "../../transcation/FromInput"
import { useHistory } from "react-router"
import { BANK_SUB_ACCOUNT_TYPES, ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD, MPOWER_ACCOUNT_TYPE_MASTER, SWP_FIRST_ORDER_FLAG_LABEL, USER_ROLES, WEEKLYDAYS } from "../../../../utils/constant"
import { setSelectedAllHoldingsInfo, setSelectedHoldingsInfo } from "../../../../redux-store/actions/investorProfile"
import MFCheckbox from "../../../../lib/formik/Checkbox"

interface CardProps {
    isLoading: boolean,
    data?: InvestmentFundType
    clientCode: string
    itemData: { units: number, folioNo: string | number, navDate: string, navValue: number, balanceAmount: number, availableUnits: number }
    navState: any;
    bankList: Array<MandateCreation> | undefined
    isSubmitting: boolean,
    id: string | number;
    folio: { folioId: string, schemeId: string, marketValue: string, investedValue: string, id: string };
    handleDelete: (checkId: string, selectedUniqueId: string) => void;
}

const Card = (props: CardProps) => {
    const { isLoading, data, clientCode, itemData, navState, bankList = [], isSubmitting, id, folio, handleDelete } = props;
    const dispatch = useDispatch()
    const { palette } = useTheme()
    const history = useHistory()
    const { pathname, state } = history.location
    const { values, errors, resetForm }: FormikProps<any> = useFormikContext()

    const { locale, currencyCode, currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);
    const {
        selectAllHoldingsInfo,
        selectedHoldingsInfo
    } = useSelector((store: RootStateType) => store.investorProfile);

    const {
        selectedPortfolioObj
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);

    const {
        role = '',
    } = useSelector((store: RootStateType) => store.auth);

    const filterValidation = values?.fund?.[id]?.investmentDetails?.validations?.filter((item: MpowerValidationType) => item?.transactionType === 'SWP')

    const currentFreq = values?.fund?.[id]?.frequency ?? "";
    const currFreqScheme = filterValidation?.find((item: MpowerValidationType) => item?.frequency === currentFreq) ?? {};

    const amcIds = ['BDOTR', 'BPIAMC']
    const checkAmcId = amcIds.includes(data?.fundAmcId ?? '') ? data?.fundAmcId?.toLowerCase() : data?.fundAmcId;

    const [open, setOpen] = useState(false)

    const Daily = data?.validations?.filter((item) => item?.frequency === 'DAILY' && item.transactionType === 'SWP')?.[0]
    const Weekly = data?.validations?.filter((item) => item?.frequency === 'WEEKLY' && item.transactionType === 'SWP')?.[0]
    const Monthly = data?.validations?.filter((item) => item?.frequency === 'MONTHLY' && item.transactionType === 'SWP')?.[0]
    const Quarterly = data?.validations?.filter((item) => item?.frequency === 'QUARTERLY' && item.transactionType === 'SWP')?.[0]
    const Yearly = data?.validations?.filter((item) => item?.frequency === 'YEARLY' && item.transactionType === 'SWP')?.[0]
    const WeeklyDays = data?.validations?.filter((item) => item?.frequency === 'WEEKLYDAYS' && item.transactionType === 'SWP')?.[0]

    const stpMinAmount = (key = 'minimumInstallmentAmount' as keyof MpowerValidationType) => {

        if (values?.frequency === 'WEEKLY') {
            return Weekly?.[key]
        } else if (values?.frequency === 'MONTHLY') {
            return Monthly?.[key]
        } else if (values?.frequency === 'QUARTERLY') {
            return Quarterly?.[key]
        } else if (values?.frequency === 'YEARLY') {
            return Yearly?.[key]
        } else if (values?.frequency === 'DAILY') {
            return Daily?.[key]
        } else if (values?.frequency === 'WEEKLYDAYS') {
            return WeeklyDays?.[key]
        } else {
            return 0
        }
    }

    const handleDateValidation = (ArrayOfDate: Array<string | number>, date: dayjs.Dayjs) => {

        if (ArrayOfDate?.length === 0) {
            return false
        }
        if (typeof ArrayOfDate?.[0] === 'number') {
            return !ArrayOfDate?.includes(dayjs(date).date());
        }

        if (typeof ArrayOfDate?.[0] === 'string') {
            const capitalizedDays = ArrayOfDate.map(day =>
                day.toString().charAt(0) + day.toString().slice(1).toLowerCase()
            );
            const day = capitalizedDays.map(item => WEEKLYDAYS.indexOf(item))
            return !day?.includes(dayjs(date).day());
        }
        return false
    }

    const handleDeleteCardValue = (scheme: string, selectedUniqueId: string) => {
        // const modifiedSelectedHoldingsInfo = selectedHoldingsInfo.filter(({ checkedId }) => checkedId !== scheme)
        // const modifiedSelectedAllHoldingsInfo = selectAllHoldingsInfo.filter(({ id: checkedId }) => checkedId !== scheme)

        const modifiedSelectedHoldingsInfo = selectedHoldingsInfo.filter(({ uniqueId }) => uniqueId !== selectedUniqueId)
        const modifiedSelectedAllHoldingsInfo = selectAllHoldingsInfo.filter(({ uniqueId }) => uniqueId !== selectedUniqueId)

        dispatch(setSelectedHoldingsInfo([...modifiedSelectedHoldingsInfo]))
        dispatch(setSelectedAllHoldingsInfo([...modifiedSelectedAllHoldingsInfo]))

        history.replace({
            state: ({
                selectedSchemes: [...modifiedSelectedAllHoldingsInfo],
                clientCode,
                schemeDetails: modifiedSelectedAllHoldingsInfo?.map((obj) => ({
                    scheme_id: obj?.schemeId ?? "-",
                    isReinvestment: obj?.isReinvest ?? "-"
                })),
                folio: [...modifiedSelectedHoldingsInfo],
            })
        })

        const newValues = values.fund.filter((item: any) => {
            // return item?.folio?.id !== scheme
            return (item?.selectedSchemeDetails?.uniqueId !== selectedUniqueId)
        })

        resetForm({
            values: {
                fund: newValues,
                ...((
                    ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                    ![USER_ROLES.INVESTOR].includes(role) &&
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    documents: values?.documents ?? []
                } : {})
            }
        })

        handleDelete(scheme, selectedUniqueId)
    }

    const selectedBankObj = (bankList ?? []).find(obj => obj?.bankAccountNumber === values?.fund?.[id]?.bankType)

    return (
        <Box sx={{ background: palette.background.paper, boxShadow: 1, borderRadius: '20px', padding: '35px 30px', display: 'flex', flexDirection: 'column', gap: '35px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '15px', overflow: 'hidden' }}>
                    {isLoading ? <CircularProgress /> :
                        <img src={checkImageExists(`${checkAmcId}`) ? `/images/amcIcons/${checkAmcId}.svg` : `/images/amcIcons/default.svg`} width={'50px'} height={'50px'} alt="Bank name" style={{ borderRadius: '8px 8px 8px 8px' }} />
                    }
                    <Box>
                        <Typography variant='body_600' color="text.primary"
                            sx={{
                                maxWidth: '100%',
                            }}>
                            {data?.fundName || ''}
                        </Typography>

                        <Box display={'flex'} flexDirection={'row'} gap={'5px'}>
                            <Typography variant='body_500' color={palette.text.secondary}
                                sx={{
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    maxWidth: { lg: '100%', md: '80%' },
                                }}>{data?.fundType || ''}
                            </Typography>
                            <Typography variant='body_500' color={palette.text.secondary}
                                sx={{
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    maxWidth: { lg: '100%', md: '80%' },
                                }}>• {data?.fundCap || ''}</Typography>
                            {/* {navState?.itemData?.riskType !== "NULL" || navState?.itemData?.riskType &&
                                <Typography variant='body_500' color={palette.success[800]}
                                    sx={{
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        maxWidth: { lg: '100%', md: '80%' },
                                    }}>• {navState?.itemData?.riskType || ''}
                                </Typography>
                            } */}
                            {(
                                `${data?.riskType ?? ""}`.toLowerCase() !== "null" || data?.riskType
                            ) &&
                                <Typography variant='body_500' color={palette.success[800]} sx={{
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    maxWidth: '100%',
                                }}>
                                    • {data?.riskType ?? ''}
                                </Typography>
                            }
                        </Box>
                        <Box sx={{ marginTop: "3px" }}>
                            <Typography
                                variant="body_500"
                                color="text.primary"
                            >
                                ISIN:{' '}
                                <Typography
                                    component="span"
                                    variant="body_500"
                                    color="text.secondary"
                                >
                                    {navState?.itemData?.isinCode ?? ''}
                                </Typography>
                            </Typography>
                        </Box>
                    </Box>


                </Box>
                {isLoading ? <Skeleton variant='text' animation="wave" width={100} /> :
                    <IconButton
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px'
                        }}
                        onClick={() => handleDeleteCardValue(folio?.id ?? "", values?.fund?.[id]?.selectedSchemeDetails?.uniqueId ?? "")}
                        disabled={isSubmitting}
                        aria-label='Delete'
                    >
                        {/* <BlueEditIcon /> */}
                        <DeleteIcons />
                        <Typography variant='body_500' color={palette.error[500]}>
                            Remove
                        </Typography>
                    </IconButton>
                }
            </Box>
            <Grid container sx={{ gap: { lg: '0px', md: '0px', sm: '0px', xs: '10px' } }}>
                <Grid item lg={3} md={6} sm={6} xs={12} sx={{
                    justifyContent: 'space-between',
                    display: 'flex',
                    flexDirection: { xs: 'row', sm: 'column', md: 'column', lg: 'column' },
                }} >
                    {isLoading ?
                        <Skeleton variant='text' animation="wave" width={100} /> : <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }}
                            variant='subtitle_400'
                            color={palette.text.secondary}>
                            Folio
                        </Typography>
                    }
                    {isLoading ?
                        <Skeleton variant='text' animation="wave" width={100} /> : <Typography
                            fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='body_500'
                            fontWeight={600}
                            color={palette.text.primary}>
                            {itemData.folioNo}
                        </Typography>}
                </Grid>
                <Grid item lg={3} md={6} sm={6} xs={12} sx={{
                    justifyContent: 'space-between',
                    display: 'flex',
                    flexDirection: { xs: 'row', sm: 'column', md: 'column', lg: 'column' },
                }} >
                    {isLoading ?
                        <Skeleton variant='text' animation="wave" width={100} /> : <Typography
                            fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='subtitle_400'
                            color={palette.text.secondary}>
                            NAV: {itemData.navDate}
                        </Typography>
                    }
                    {isLoading ?
                        <Skeleton variant='text' animation="wave" width={100} /> : <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='body_500'
                            fontWeight={600}
                            color={palette.text.primary}>
                            {formatCurrency({ value: itemData.navValue, locale, currencyCode })}
                        </Typography>}
                </Grid>
                <Grid item lg={3} md={6} sm={6} xs={12} sx={{
                    justifyContent: 'space-between',
                    display: 'flex',
                    flexDirection: { xs: 'row', sm: 'column', md: 'column', lg: 'column' },
                }} >
                    {isLoading ?
                        <Skeleton variant='text' animation="wave" width={100} /> : <Typography
                            fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='subtitle_400'
                            color={palette.text.secondary}>
                            Balance Unit
                        </Typography>
                    }
                    {isLoading ?
                        <Skeleton variant='text' animation="wave" width={100} /> : <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }}
                            variant='body_500'
                            fontWeight={600}
                            color={palette.text.primary}>
                            {itemData?.units ?? 0}
                        </Typography>
                    }
                </Grid>
                <Grid item lg={3} md={6} sm={6} xs={12} sx={{
                    justifyContent: 'space-between',
                    display: 'flex',
                    flexDirection: { xs: 'row', sm: 'column', md: 'column', lg: 'column' },
                }} >
                    {isLoading ?
                        <Skeleton variant='text' animation="wave" width={100} /> : <Typography
                            fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='subtitle_400'
                            color={palette.text.secondary}>
                            Balance Amount
                        </Typography>
                    }
                    {isLoading ?
                        <Skeleton variant='text' animation="wave" width={100} /> : <Typography
                            fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='body_500'
                            fontWeight={600}
                            color={palette.text.primary}>
                            {formatCurrency({ value: itemData?.balanceAmount, locale, currencyCode })}
                        </Typography>}
                </Grid>
            </Grid>
            <Divider />
            <Typography variant='h2' fontSize={{ sm: '18px', xs: '18px', md: '20px', lg: '20px' }}  >SWP Details</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                    <CustomeNumberInput
                        name={`fund.${id}.amount`}
                        textType='number'
                        minlabel={`Min:${String.fromCharCode(parseInt(currencySymbol, 16))} ${Number(currFreqScheme?.minimumInstallmentAmount ?? 0)}`}
                        label='SWP Amount'
                        isLoading={isLoading}
                        disable={isSubmitting}
                        // minValue={stpMinAmount('minimumInstallmentAmount')}
                        // warningText='Rupees Five Thousand' 
                        warningText={'amount'}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                    <CustomeBlueDropDown
                        name={`fund.${id}.frequency`}
                        isLoading={isLoading}
                        disabled={isSubmitting}
                        label='SWP Frequency'
                        list={data?.frequencies?.filter((item) => item?.frequency && item.tranasactionType === "SWP").map((item) => ({ value: item?.frequency, label: item?.frequency })) as any}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={6} mt={2}>
                    <CustomeBlueDatePicker
                        name={`fund.${id}.swpDate`}
                        disablePast
                        isLoading={isLoading}
                        disabled={isSubmitting}
                        label='SWP Date'
                        shouldDisableDate={(date: dayjs.Dayjs) => handleDateValidation(currFreqScheme?.investmentDates ?? [], date)}
                        minDate={dayjs().add(1, 'day')}
                    // disableDateList={stpMinAmount('investmentDates')}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={6} mt={2}>
                    <CustomeNumberInput
                        removeIcons
                        name={`fund.${id}.installment`}
                        isLoading={isLoading}
                        disable={isSubmitting}
                        label='No. of Installments'
                        minValue={Number(`${currFreqScheme?.minimumInstallments ?? 0}`)}
                        minlabel={`Min: ${currFreqScheme?.minimumInstallments ?? 0}`} />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                    <CustomeBlueDropDown
                        name={`fund.${id}.bankType`}
                        isLoading={isLoading}
                        disabled={isSubmitting}
                        list={[...bankList].map((item) => ({
                            value: item?.bankAccountNumber,
                            label: `
                            ${item?.bankName}-${item?.bankAccountNumber} 
                            ${BANK_SUB_ACCOUNT_TYPES[`${item?.bankSubAccountType ?? ""}`.toUpperCase()] ? "(" + BANK_SUB_ACCOUNT_TYPES[`${item?.bankSubAccountType ?? ""}`.toUpperCase()] + ")" : ""}
                            `
                        }))}
                        label='Select Bank'
                    />
                    {(
                        !isLoading &&
                        (Object.keys(selectedBankObj ?? {}).length > 0)
                    ) && (
                            <Typography
                                variant='body_500'
                                sx={{
                                    color: palette.text.secondary,
                                    marginTop: "5px"
                                }}
                            >
                                Bank Sub Account Type: {`${BANK_SUB_ACCOUNT_TYPES[`${selectedBankObj?.bankSubAccountType ?? ""}`.toUpperCase()] ?? "-"}`}
                            </Typography>
                        )}
                </Grid>
                <Grid item xs={12} md={6}>
                    {(isLoading) && (
                        <Skeleton
                            animation="wave"
                            width="100%"
                            sx={{
                                padding: '30px',
                                borderRadius: 2,
                                mt: "15px"
                            }}
                        />
                    )}
                    {(!isLoading) && (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px'
                            }}
                        >
                            <Box sx={{ height: "24px", display: { xs: 'none', md: 'block' } }} />
                            <Box
                                sx={{
                                    mt: { xs: 3, md: 0 },
                                    padding: '5px 0px 4px 15px',
                                    backgroundColor: palette.primary[50],
                                    borderRadius: 2
                                }}
                            >
                                <MFCheckbox
                                    name={`fund[${id}].firstOrder`}
                                    label={SWP_FIRST_ORDER_FLAG_LABEL}
                                    disabled={isSubmitting}
                                />
                            </Box>
                        </Box>
                    )}
                </Grid>
            </Grid>
            {open &&
                <HoldingModal open={open} setOpen={setOpen} clientCode={navState.clientCode} />
            }
        </Box>
    )
}

export default Card